import React from 'react';
import {Map} from 'immutable';
import {SHARED_FORM_CONSTRAINTS_DESCENDANTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {
  Environment,
  WebflowEnvironments,
} from '@packages/systems/core-constants';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import withAttribute from './withAttribute';
import {
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_EMPTY_STATE,
  SHIPPING_METHODS_STATES,
} from '@packages/systems/commerce/constants';
import {smokeGrey} from './Bootflow';
import {createRgbaColor} from '@packages/systems/core/utils/ColorUtils';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';

import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {useRuntimeEnvironment} from '@packages/systems/render';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const styleDisplayNone = Map({style: Map({display: 'none'})});

const shouldThisComponentBeShown = ({
  runtimeEnvironment,
  shippingMethodState,
}: {
  runtimeEnvironment: Environment;
  shippingMethodState: unknown;
}) => {
  const isDesigner = runtimeEnvironment === WebflowEnvironments.DESIGNER;

  if (isDesigner) {
    return shippingMethodState === SHIPPING_METHODS_STATES.EMPTY;
  }
  return false;
};

const CommerceCheckoutShippingMethodsEmptyState = Atom.createRender((props) => {
  const {attributes, classes, context, data, generateAttributes, renderChild} =
    props;
  const runtimeEnvironment = useRuntimeEnvironment();
  const shippingMethodState: unknown = context.get('shippingMethodState');

  const styledAttributes = shouldThisComponentBeShown({
    runtimeEnvironment,
    shippingMethodState,
  })
    ? attributes
    : attributes.merge(styleDisplayNone);
  return (
    <div {...generateAttributes(styledAttributes, classes)}>
      {getChildren(data).map((child: EvaluatedNodeData) => renderChild(child))}
    </div>
  );
});

const config = createIntegratedAtom({
  displayName: 'Empty State',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Dynamo'), iconName('CollectionBlock')),
  },
  showEmpty: true,
  constraints: {
    ancestors: [
      {is: 'CommerceCheckoutShippingMethodsWrapper', rule: 'ExactlyOne'},
    ],
    descendants: [...SHARED_FORM_CONSTRAINTS_DESCENDANTS],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          textAlign: 'center',
          paddingLeft: px(16),
          paddingRight: px(16),
          paddingTop: px(64),
          paddingBottom: px(64),
          borderLeftStyle: 'solid',
          borderLeftWidth: px(1),
          borderLeftColor: smokeGrey,
          borderRightStyle: 'solid',
          borderRightWidth: px(1),
          borderRightColor: smokeGrey,
          borderBottomStyle: 'solid',
          borderBottomWidth: px(1),
          borderBottomColor: smokeGrey,
          backgroundColor: createRgbaColor('ffffff'),
        },
      },
    },
  },
  render: withAttribute(
    DATA_ATTR_NODE_TYPE,
    NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_EMPTY_STATE
  )(CommerceCheckoutShippingMethodsEmptyState),
  fields: {children: TListOfElement},
});

export default config;
